import React from 'react'
import {
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  ArrowLeft,
  PlusCircle,
  Exchange,
  Upload,
  Settings,
  ArrowBigRight,
  ArrowUpUnderline,
  QRCode,
  QrCodeBox,
  Copy,
  CopyFilled,
  ArrowBigDown,
  SmallArrowUp,
  SmallArrowDown,
  Search,
  Close,
  Clock,
  ApplePay,
  GooglePay,
  Card,
  Bank,
  Dollar,
  Pin,
  Unpin,
  Warning,
  SmallInfo,
  Expand,
  Eye,
  EyeOff,
  Edit,
  Ellipses,
  Wallet,
  Lock,
  Flash,
  Switch,
  Bell,
  ArrowDownCircle,
  ArrowRightCircle,
  Identity,
  EmailInline,
  Phone,
  Check,
  Unlock,
  DoubleChevronUp,
  GroupIcon,
  ReactIcon,
} from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import { getThemeColorValue } from '@/utils'
import { TwoArrowsIcon } from '../TabIcons'

// Маппинг иконок по именам
const IconMap = {
  arrowUp: ChevronUp,
  arrowDown: ChevronDown,
  arrowLeft: ArrowLeft,
  arrowBigRight: ArrowBigRight,
  arrowBigDown: ArrowBigDown,
  arrowUpUnderline: ArrowUpUnderline,
  smallArrowUp: SmallArrowUp,
  smallArrowDown: SmallArrowDown,
  chevronUp: ChevronUp,
  doubleChevronUp: DoubleChevronUp,
  refresh: Switch,
  switch: Switch,
  swap: Exchange,
  exchange: Exchange,
  plus: PlusCircle,
  plusCircle: PlusCircle,
  minus: ChevronDown, // Fallback
  activity: Settings, // Fallback
  qrCode: QRCode,
  qrCodeBox: QrCodeBox,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  upload: Upload,
  settings: Settings,
  copy: Copy,
  copyFilled: CopyFilled,
  search: Search,
  close: Close,
  smallClose: Close,
  clock: Clock,
  identity: Identity,
  check: Check,
  // Notification icons
  bell: Bell,
  // Payment method icons
  applePay: ApplePay,
  googlePay: GooglePay,
  card: Card,
  cardFilled: Card,
  bank: Bank,
  dollar: Dollar,
  wallet: Wallet,
  // Pin icons
  pin: Pin,
  unpin: Unpin,
  lock: Lock,
  checkmark: ChevronUp, // Temporary fallback
  warning: Warning,
  triangleWarning: Warning,
  roundedWarning: Warning,
  more: Settings, // Temporary fallback
  gift: PlusCircle, // Temporary fallback
  expand: Expand, // For expandable notes
  // Eye icons for card visibility
  eye: Eye,
  eyeOff: EyeOff,
  // Additional icons for card actions
  lockFilled: Pin,
  unlockFilled: Unlock,
  pencilDraw: Settings,
  archiveBox: Settings,
  googleWallet: GooglePay,
  smallInfo: SmallInfo,
  edit: Edit,
  ellipses: Ellipses,
  flash: Flash,
  flashlight: Flash,
  // Savings transaction icons
  arrowDownCircle: ArrowDownCircle,
  arrowRightCircle: ArrowRightCircle,
  emailInline: EmailInline,
  phone: Phone,
  groupIcon: GroupIcon,
  react: ReactIcon,
  twoArrowsIcon: TwoArrowsIcon,
}

interface AppIconsProps {
  name: string
  size?: number
  color?: string
  secondColor?: string
  unthemedColor?: string
}

export const AppIcons: React.FC<AppIconsProps> = ({
  name,
  size = 24,
  color,
  secondColor,
  unthemedColor,
}) => {
  const theme = useTheme()

  // Получаем компонент иконки
  const IconComponent = IconMap[name as keyof typeof IconMap] || Settings

  // Resolve theme color like in RN version
  const resolvedColor = color
    ? getThemeColorValue(theme.colors, color)
    : undefined

  // Определяем цвет иконки (adapted from RN)
  const iconColor =
    unthemedColor ||
    resolvedColor ||
    (name === 'applePay'
      ? 'white'
      : name === 'googlePay'
        ? undefined
        : theme.colors.label.default)

  return (
    <IconComponent size={size} color={iconColor} secondColor={secondColor} />
  )
}
